module.exports = __webpack_public_path__ + "img/text.5c559d1d.svg";